var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningInverted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9004 13.3001L7.40039 1.30015C7.30039 1.00015 7.00039 0.900146 6.80039 1.10015C6.70039 1.10015 6.60039 1.20015 6.60039 1.30015L0.100391 13.3001C0.000390625 13.5001 0.000390625 13.6001 0.100391 13.8001C0.200391 13.9001 0.300391 14.0001 0.500391 14.0001H13.5004C13.7004 14.0001 13.8004 13.9001 13.9004 13.8001C14.0004 13.6001 14.0004 13.4001 13.9004 13.3001ZM6.40039 5.50015H7.50039V9.50015H6.40039V5.50015ZM7.00039 12.2001C6.60039 12.2001 6.20039 11.9001 6.20039 11.4001C6.20039 10.9001 6.50039 10.6001 7.00039 10.6001C7.40039 10.6001 7.80039 10.9001 7.80039 11.4001C7.80039 11.9001 7.40039 12.2001 7.00039 12.2001Z",
    fill: "#F43F5E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningInverted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-inverted.21743b2dedf6413c8924464da613bf78.svg";